import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { EmptyResponseEntity } from '~client/model/empty-response-entity';
import { PaymentMeans } from '~client/model/payment-means';
import { PaymentMeansRequest } from '~client/model/payment-means-request';
import { PaymentMeansUpdateRequest } from '~client/model/payment-means-update-request';
import { PaymentMethodsResponse } from '~client/model/payment-methods-response';

/* User APIs pertaining to payments */
export class PaymentController extends BaseController {
  /* Gets the payment means and external payment methods for the user */
  public getPaymentMethods(): Promise<PaymentMethodsResponse> {
    return this.get('/payment/paymentMethods');
  }

  /*
  @deprecated
   */
  public getPaymentMeans$(): Observable<PaymentMeans[]> {
    return this.get$('/payment/paymentMeans');
  }

  /* Creates or updates the existing payment means of a user with the single use token provided */
  public createPaymentMethod$(request: PaymentMeansRequest): Observable<PaymentMeans> {
    return this.post$('/payment/paymentMeans', request);
  }

  /* Deletes an existing payment means */
  public deletePaymentMethod$(paymentMethodId: string): Observable<PaymentMeans[]> {
    return this.del$('/payment/paymentMeans', { paymentMethodId });
  }

  /* Updates the existing payment means of a user with the address information provided */
  public updatePaymentMethod$(request: PaymentMeansUpdateRequest): Observable<PaymentMeans[]> {
    return this.put$('/payment/paymentMeans/update', request);
  }

  /* Allows the user to retry marketplace payment with a offer id */
  public repayment$(
    fraudSessionId: string,
    offerId: string,
    paymentMethodId: string,
  ): Observable<EmptyResponseEntity> {
    return this.put$(
      `/payment/marketplace/repayment?fraudSessionId=${fraudSessionId}&offerId=${offerId}&paymentMethodId=${paymentMethodId}`,
    );
  }

  /* Verifies the payment method for provided payment method id */
  public verifyPaymentMethod$(paymentMethodId: number): Observable<PaymentMeans> {
    return this.put$(`/payment/paymentMeans/verify?paymentMethodId=${paymentMethodId}`);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/controller/payment-controller.ts